export class ReportADAExtraParams {
  diagCodeListQualifierA: string;
  diagCodeListQualifierB: string;
  diagCodePrimA: string;
  diagCodePrimB: string;
  diagCodePrimC: string;
  diagCodePrimD: string;
  remarks: string;
}
